import { render } from "./SocialmediaComponent.vue?vue&type=template&id=6abdaf06&scoped=true"
import script from "./SocialmediaComponent.vue?vue&type=script&lang=js"
export * from "./SocialmediaComponent.vue?vue&type=script&lang=js"

import "./SocialmediaComponent.vue?vue&type=style&index=0&id=6abdaf06&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\LENOVO\\Documents\\workspace\\tulumoutdoor_website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6abdaf06"]])

export default __exports__